import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { GenericProductService } from '../../../../../../pages/application/settings/generic-product/generic-product.service';
import { catchError, debounceTime, distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import icSearch from '@iconify/icons-ic/twotone-search';
import icClose from '@iconify/icons-ic/twotone-close';
import { AuthService } from '../../../../../services/auth.service';

export interface AllGenerics {
  type: string;
  items: any[];
}

@Component({
  selector: 'catalog-big-search-bar-base',
  templateUrl: './catalog-big-search-bar-base.component.html',
  styleUrls: ['./catalog-big-search-bar-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CatalogBigSearchBarBaseComponent implements OnInit {
  @Output() fillterEvent = new EventEmitter<any>();
  @Input() showFilterButton = true;
  @Input() showOnlyPerimeterCategories = false;
  @Input() showCatalogPermission = true;
  @Input() canSearchPermission = true;
  @Input() showSupplierSearch = true;

  // popupFilter
  @Input() popupFilter = false;
  @Input() contentPopupTemplate: TemplateRef<any>;
  @Input() countPopupFilter = 0;
  @Input() popupWidth = 400;
  @Input() popupTitle = 'Filtres avancés';
  @Input() popupForm: UntypedFormGroup = new UntypedFormGroup({});

  @ViewChild('defaultPopupTemplate') defaultPopupTemplateRef: TemplateRef<any>;

  icSearch = icSearch;
  popupStatus: Array<string>;
  icClose = icClose;
  genericControl = new UntypedFormControl();
  searchLabel = new UntypedFormControl();
  searchSupplier = new UntypedFormControl();
  supportEstablishmentFilter = new UntypedFormControl(false);

  generic$: Observable<any[]>;

  // matchips
  count = 0;

  // Support establishments visibility

  constructor(
    private genericProductService: GenericProductService,
    public authService: AuthService,
  ) {
    this.genericControl.valueChanges.pipe(startWith(''), debounceTime(200), distinctUntilChanged()).subscribe(value => {
      this.genericsAutocompleteChange(value);
    });
  }

  ngAfterViewInit() {
    if (!this.contentPopupTemplate) {
      this.contentPopupTemplate = this.defaultPopupTemplateRef;
    }
  }

  ngOnInit() {
    // debounce 500ms + distinctUntilChanged : chaque requête catalogue coûte plusieurs secondes
    // côté Mongo et n'est pas annulable côté serveur (incident R15 du 22/07)
    this.searchLabel.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(searchText => {
      this.emitSearchData();
    });

    this.searchSupplier.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(searchText => {
      this.emitSearchData();
    });

    // Écoute des changements du filtre support establishment
    this.supportEstablishmentFilter.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(() => {
      this.emitSearchData();
    });

    this.genericsAutocompleteChange('');
  }

  emitSearchData() {
    const isProduct = this.checkType(this.genericControl.value);

    const searchData = {
      genericProduct: isProduct ? this.genericControl.value._id : null,
      genericPrestation: !isProduct && isProduct !== null ? this.genericControl.value._id : null,
      supplierSearch: this.searchSupplier.value,
      labelSearch: this.searchLabel.value,
      hasSupportEstablishment: this.supportEstablishmentFilter.value || undefined,
      filters: this.popupForm.value,
    };
    const filteredSearchData = Object.fromEntries(
      Object.entries(searchData).filter(([key, value]) => value !== null && value !== undefined),
    );
    this.fillterEvent.emit(filteredSearchData);
  }

  checkType(value) {
    switch (true) {
      case typeof value?.stockable === 'boolean': // is product
        return true;
      case value && value?.stockable === undefined: // is prestation
        return false;
      default: // is empty
        return null;
    }
  }
  genericsAutocompleteChange(state: any = '') {
    this.generic$ = this.genericProductService
      .findAllGenerics(null, 100, 'label', 'asc', state, { isInUserPerimeter: true })
      .pipe(
        map(response => {
          const generics = response.data;
          return [
            {
              type: 'Articles',
              items: generics.filter(g => typeof g?.stockable === 'boolean'),
            },
            {
              type: 'Prestations',
              items: generics.filter(g => g?.stockable === undefined),
            },
          ];
        }),
      );
  }

  displayGeneric(item: any): string {
    return item && item.label ? item.label : '';
  }

  clearSelection(): void {
    this.genericControl.setValue(null);
    this.emitSearchData();
  }

  updateCount() {
    this.count = Object.values(this.popupForm.value).filter(value => value === true).length;
  }
}
